import { Dialog, DialogContent, DialogTitle, List, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import { Persona } from './personaApi'
import messages from './personaMessages'

// E8 F8-4.2 — the multi-persona picker. A modal the user MUST resolve: no cancel / close affordance and
// no onClose handler, because there is no valid app state without a chosen persona. Rendered as an
// accessible listbox (role=listbox + role=option) so it's keyboard- and screen-reader-navigable.
const PersonaPicker = ({ personas, onPick }: { personas: Persona[]; onPick: (userId: number) => void }) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog open fullWidth maxWidth='xs' aria-labelledby='persona-picker-title'>
      <DialogTitle id='persona-picker-title'>{formatMessage(messages.pickerTitle)}</DialogTitle>
      <DialogContent>
        <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
          {formatMessage(messages.pickerSubtitle)}
        </Typography>
        <List role='listbox' aria-labelledby='persona-picker-title'>
          {personas.map((persona) => (
            <ListItemButton key={persona.userId} role='option' onClick={() => onPick(persona.userId)}>
              <ListItemText
                primary={
                  persona.isTenantDirect
                    ? persona.tenantDisplayName
                    : `${persona.tenantDisplayName} — ${persona.customerDisplayName}`
                }
                secondary={persona.isAccountOwner ? formatMessage(messages.accountOwner) : undefined}
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  )
}

export default PersonaPicker
